import { DalProvider } from './dal/dal';
import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
// import { M_USER } from '../models/M_USER';
// import { Ortak } from '../providers/ortak';
// import "reflect-metadata";

//export type ObjectType<T> = { new (): T } | Function;
/*
  Generated class for the Database provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/


@Injectable()
export class Database {

  private type: string;
  constructor(type?: string) {
    this.type = type;

  }

  getAll(entity?: any) {
    return new Promise((res, err) => {
      var tableViewName = this.type;
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var eklenenKayitlar: number[] = [];

        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];

        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "select * from " + tableViewName;
        if (entity != null) {
          sqlQuery = sqlQuery + " where "
        }
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {

            sqlQueryFieldsArray.push(key + "=?")
            sqlQueryValuesArray.push(entity[key]);
            // sqlQueryParamsArray.push("?");
          } else {
            //alert(key + " is not a public property.");
          }

        }
        var sqlQueryFields: string = sqlQueryFieldsArray.join(' and ');
        sqlQuery = sqlQuery + sqlQueryFields;
   
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          // resolve(result);
          var sonuc = [];
          for (var index = 0; index < result.rows.length; index++) {
            var element = result.rows.item(index);
            sonuc.push(element);
          }
          res(sonuc);


        }, function (tx, x) {
          console.log("SQL_ERROR: " ,x);
          err(x);
        });
      });
    })
  }

  getAllWithSpecificParams(conditions: string) {
    return new Promise<any[]>((resolve, reject) => {

    });
  }



  bulkInsert(entities: Array<any>, tableName: string) {
    // let tableName = Describer.getName(entity);
    return new Promise((res, err) => {
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var eklenenKayitlar: number[] = [];
        entities.forEach(entity => {
          i = i + 1;
          var sqlQuery: string = "";
          var sqlQueryFieldsArray: string[] = [];
          var sqlQueryExt: string = "";
          var sqlQueryParamsArray: string[] = [];
          var sqlQueryValuesArray: string[] = [];
          sqlQuery = sqlQuery + "insert into " + tableName + " (";
          sqlQueryExt = sqlQueryExt + " values("
          for (let key in entity) {
            if (entity.hasOwnProperty(key) && typeof key !== 'function') {
              sqlQueryFieldsArray.push(key)
              sqlQueryValuesArray.push(entity[key]);
              sqlQueryParamsArray.push("?");
            } else {
              //alert(key + " is not a public property.");
            }

          }
          var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
          var sqlQueryParams: string = sqlQueryParamsArray.join(',')
          sqlQuery = sqlQuery + sqlQueryFields + ")" + sqlQueryExt + sqlQueryParams + ") ";
          tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
            // resolve(result);
            eklenenKayitlar.push(result.insertId);

          }, function (tx, x) {
            err(x);
          });
          if (i >= entities.length) {
            res();
          }
        });
        if (entities.length <= 0) {
          res();
        }
      });
    })
  }


  bulkUpdate(entities: Array<any>, tableName: string, whereCondition: string) {
    // let tableName = Describer.getName(entity);
    return new Promise((res, err) => {

      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var guncellenenKayitlar: number[] = [];
        entities.forEach(entity => {
          i = i + 1;
          var sqlQuery: string = "";
          var sqlQueryFieldsArray: string[] = [];
          var sqlQueryValuesArray: string[] = [];
          sqlQuery = sqlQuery + "update " + tableName + " set ";
          // sqlQueryExt = sqlQueryExt + " values("
          for (let key in entity) {
            if (entity.hasOwnProperty(key) && typeof key !== 'function') {
              sqlQueryFieldsArray.push(key + "=?")
              sqlQueryValuesArray.push(entity[key]);
              // sqlQueryParamsArray.push("?");
            } else {
              //alert(key + " is not a public property.");
            }

          }
          sqlQueryValuesArray.push(entity[whereCondition]);
          var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
          sqlQuery = sqlQuery + sqlQueryFields + " WHERE " + whereCondition + " = ?";

          tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
            // resolve(result);
            // guncellenenKayitlar.push(result.insertId);

          }, function (tx, x) {
            console.log(x);
            err(x);
          });
          if (i >= entities.length) {
            res(guncellenenKayitlar);
          }
        });
        if (entities.length <= 0) {
          res();
        }

      });
    })
  }
  addOrUpdate(entity) {
    return new Promise((res, err) => {
      var tableName = this.type;
      var db = Database.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var eklenenKayitlar: number[] = [];

        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];
        var sqlQueryExt: string = "";
        var sqlQueryParamsArray: string[] = [];
        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "replace into " + tableName + " (";
        sqlQueryExt = sqlQueryExt + " values("
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {
            sqlQueryFieldsArray.push(key)
            sqlQueryValuesArray.push(entity[key]);
            sqlQueryParamsArray.push("?");
          } else {
            //alert(key + " is not a public property.");
          }

        }
        var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
        var sqlQueryParams: string = sqlQueryParamsArray.join(',')
        sqlQuery = sqlQuery + sqlQueryFields + ")" + sqlQueryExt + sqlQueryParams + ") ";
      
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          // resolve(result);
      

          entity.ID = result.insertId;
          res(entity);



        }, function (tx, x) {
          console.log("SQL_ERROR - ADD: ", x);
          err(x);
        });
      });
    })
  }


  add(entity: any) {
    return new Promise((res, err) => {
      var tableViewName = this.type;
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var eklenenKayitlar: number[] = [];

        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];
        var sqlQueryExt: string = "";
        var sqlQueryParamsArray: string[] = [];
        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "insert into " + tableViewName + " (";
        sqlQueryExt = sqlQueryExt + " values("
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {
            sqlQueryFieldsArray.push(key)
            sqlQueryValuesArray.push(entity[key]);
            sqlQueryParamsArray.push("?");
          } else {
            //alert(key + " is not a public property.");
          }

        }
        var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
        var sqlQueryParams: string = sqlQueryParamsArray.join(',')
        sqlQuery = sqlQuery + sqlQueryFields + ")" + sqlQueryExt + sqlQueryParams + ") ";
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          // resolve(result);
          res();

        }, function (tx, x) {
          console.log("SQL_ERROR: " ,x);
          err(x);
        });
      });
    })
  }

  update(entity: any, whereCondition: string) {
    return new Promise((res, err) => {
      var tableViewName = this.type;
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var guncellenenKayitlar: number[] = [];
        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];
        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "update " + tableViewName + " set ";
        // sqlQueryExt = sqlQueryExt + " values("
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {
            sqlQueryFieldsArray.push(key + "=?")
            sqlQueryValuesArray.push(entity[key]);
            // sqlQueryParamsArray.push("?");
          } else {
            //alert(key + " is not a public property.");
          }

        }
        sqlQueryValuesArray.push(entity[whereCondition]);
        var sqlQueryFields: string = sqlQueryFieldsArray.join(',');
        sqlQuery = sqlQuery + sqlQueryFields + " WHERE " + whereCondition + " = ?";
        console.log("Update query", sqlQuery, sqlQueryValuesArray);
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          res();

        }, function (tx, x) {
          console.log(x);
          err(x);
        });

      });
    })
  }



  delete(entity: any) {
    return new Promise((res, err) => {
      var tableViewName = this.type;
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        var i = 0;
        var eklenenKayitlar: number[] = [];

        var sqlQuery: string = "";
        var sqlQueryFieldsArray: string[] = [];

        var sqlQueryValuesArray: string[] = [];
        sqlQuery = sqlQuery + "delete from " + tableViewName;
        if (entity != null) {
          sqlQuery = sqlQuery + " where "
        }
        for (let key in entity) {
          if (entity.hasOwnProperty(key) && typeof key !== 'function') {

            sqlQueryFieldsArray.push(key + "=?")
            sqlQueryValuesArray.push(entity[key]);
            // sqlQueryParamsArray.push("?");
          } else {
            //alert(key + " is not a public property.");
          }

        }
        var sqlQueryFields: string = sqlQueryFieldsArray.join(' and ');
        sqlQuery = sqlQuery + sqlQueryFields;
        // console.log(sqlQuery)
        tx.executeSql(sqlQuery, sqlQueryValuesArray, function (tx, result) {
          // resolve(result);
          res();

        }, function (tx, x) {
          err(x);
        });
      });
    })
  }

  deleteAll(name: string) {
    return new Promise((resolve, reject) => {
      // let repository = getConnection("default").getRepository(this.type);
      // repository.query("DELETE FROM " + name).then(sonuc => {

      //   resolve(sonuc);
      // }, (err) => {
      //   reject(err);
      // });
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        tx.executeSql("DELETE FROM " + name, [], function (tx, result) {
          resolve(result);
        }, function (tx, err) {
          reject(err);
        });
      });
    });
  }
  deleteAll2() {
    return new Promise((resolve, reject) => {
      var db = Database.sqliteWebSqlDbObject();
      var tableName = this.type;
      db.transaction(function (tx) {
        tx.executeSql("DELETE FROM " + tableName, [], function (tx, result) {
          resolve(result);
        }, function (tx, err) {
          console.log("SQL_ERROR - DELETE ALL: ", err);
          reject(err);
        });
      });
    });
  }


  execRawQuery(query: string) {
    return new Promise<any>((resolve, reject) => {
      // let repository =  getConnection("default").getRepository(M_USER);
      // repository.query(query).then(sonuc => {
      //   resolve(sonuc);
      // }, (err) => {
      //   reject(err);
      // });
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        tx.executeSql(query, [], function (tx, result) {
          resolve(result);
        }, function (tx, err) {

        });
      });
    });
  }
  static sqliteWebSqlDbObject() {
    return DalProvider.connection;
  }
  execRawQueryWithParams(query: string, params: any) {
    return new Promise<any>((resolve, reject) => {
      // let repository =  getConnection("default").getRepository(M_USER);
      // repository.query(query).then(sonuc => {
      //   resolve(sonuc);
      // }, (err) => {
      //   reject(err);
      // });
      var db = this.sqliteWebSqlDbObject();
      db.transaction(function (tx) {
        tx.executeSql(query, params, function (tx, result) {
          resolve(result);
        }, function (tx, err) {

        });
      });
    });
  }


  sqliteWebSqlDbObject() {
    // var connection: any = getConnection("default");
    // return connection.driver.databaseConnection.connection;
    return DalProvider.connection;
  }

}


// class Describer {
//   static getName(inputClass) {
//     var funcNameRegex = /function (.{1,})\(/;
//     var results = (funcNameRegex).exec((<any>inputClass).constructor.toString());
//     return (results && results.length > 1) ? results[1] : "";
//   }
// }


// WEBPACK FOOTER //
// ./src/providers/database.ts